var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contractors-info__inviting-modal" },
    [
      _c(
        "HKLModal",
        {
          ref: "modal",
          attrs: {
            title: _vm.$t("hint.inviteAllUsers"),
            okBtnAction: "yesInvite",
          },
          on: { onOkClick: _vm.saveAndSendInviteEmails },
        },
        [
          _c("div", { staticClass: "invite-user__slot" }, [
            _vm.shouldInvitedMainContractors.length
              ? _c("div", { staticClass: "invite-users__body" }, [
                  _c("div", { staticClass: "invite-users__title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("mainContractor")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "invite-users__list" },
                    _vm._l(_vm.shouldInvitedMainContractors, function (item) {
                      return _c("li", { key: item.id }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(item.primaryContact.email) +
                            "\n          "
                        ),
                      ])
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _vm.shouldInvitedSubContractors.length
              ? _c("div", { staticClass: "invite-users__body" }, [
                  _c("div", { staticClass: "invite-users__title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("subContractorWithS")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "invite-users__list" },
                    _vm._l(_vm.shouldInvitedSubContractors, function (item) {
                      return _c("li", { key: item.id }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(item.primaryContact.email) +
                            "\n          "
                        ),
                      ])
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }